import { Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { ThumbDown, ThumbUp } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { withFirebase } from "../Firebase";
import { withAuthorization } from "../Session";

const Rescuers = (props) => {
  const [rescuers, setRescuers] = useState({});
  const [newRescuer, setNewRescuer] = useState(null);
  const { firebase } = props;
  const [count, setCount] = useState(0);

  const updateRescuer = (data) => {
    rescuers[data.uid] = data;

    //setRescuers((rescuers[data.uid] = data));
  };

  useEffect(() => {
    if (!!newRescuer) {
      rescuers[newRescuer.uid] = newRescuer;
      setRescuers(rescuers);
      setNewRescuer(null);
    }
  }, [newRescuer]);

  useEffect(() => {
    firebase
      .users()
      .once("value")
      .then((snap) => {
        let rescuersaux = {};
        Object.keys(snap.val()).map((key) => {
          if (typeof snap.val()[key].info.dni !== "undefined") {
            rescuersaux[key] = snap.val()[key].info;
          }
        });
        setRescuers(rescuersaux);
        //console.log(rescuersaux);
        setCount(Object.keys(rescuersaux).length);
      });

    firebase.users().on("child_changed", (snap, prevChildKey) => {
      //setNewRescuer(snap.val().info);

      firebase
        .users()
        .once("value")
        .then((snap) => {
          let rescuersaux = {};
          Object.keys(snap.val()).map((key) => {
            if (typeof snap.val()[key].info.dni !== "undefined") {
              rescuersaux[key] = snap.val()[key].info;
            }
          });
          setRescuers(rescuersaux);
          //console.log(rescuersaux);
          setCount(Object.keys(rescuersaux).length);
        });
    });
  }, []);

  return (
    <Container>
      <Grid container>
        <h3>Numero de Inscripciones: {count} </h3>
      </Grid>
      <Grid container justify="center" alignItems="center" style={{ minHeight: "100vh" }}>
        <TableContainer component={Paper} style={{ marginTop: 32 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Email</TableCell>
                <TableCell align="right">Nombre</TableCell>
                <TableCell align="right">Apellido 1</TableCell>
                <TableCell align="right">Apellido 2</TableCell>
                <TableCell align="right">DNI</TableCell>
                <TableCell align="right">Autorización</TableCell>
                <TableCell align="right">Comunicaciones</TableCell>
                <TableCell>Id</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(rescuers).map((key) => (
                <TableRow key={key}>
                  <TableCell>{rescuers[key].email}</TableCell>
                  <TableCell align="right">{rescuers[key].name}</TableCell>
                  <TableCell align="right">{rescuers[key].surname}</TableCell>
                  <TableCell align="right">{rescuers[key].secondSurname}</TableCell>
                  <TableCell align="right">{rescuers[key].dni}</TableCell>
                  <TableCell align="right">{rescuers[key].autorizacion ? <ThumbUp color="primary" /> : <ThumbDown style={{ color: red[500] }}></ThumbDown>}</TableCell>
                  <TableCell align="right">{rescuers[key].comunicaciones ? <ThumbUp color="primary" /> : <ThumbDown style={{ color: red[500] }}></ThumbDown>}</TableCell>
                  <TableCell>{key}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Container>
  );
};

const condition = (
  authUser //console.log("console", authUser.sgpfc.rol);
) => (!!authUser ? authUser.sgpfc.rol === "admin" : false); //&& authUser.uid === "t4G2Ar2jnWOr52B5W96xn0tbKOW2";

export default withAuthorization(condition)(Rescuers);
